import status from './status';
import appointmentStatusMapping from './appointment-status-mapping';

export const appointment = {
    status,
    appointmentStatusMapping,
};
